import {css} from "@emotion/react";

export const row = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
      align-items: center;
    justify-content: center;
`;

export const borderBottom = css`
    border-bottom: 0.5px solid #C5CACE;
`;

export const column = css`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    align-items: center;
    justify-content: center;
`;

export const blueColumn = css`
    background-image: linear-gradient(#449DF7,#006FE0);
    color: white;
`;


export const centerText = css`
    margin-right: 10px;
    font-size: 18px;
`;

export const centerTextLeft = css`
    margin:0;
    margin-right:5px;
    font-size: 45px;
`;

export const lightColumn = css`
    background-image: linear-gradient(#E6FFFF,#ADFFFF);
    color: #0068D1;
`;

export const columnStructure = css`
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;


export const yellowColumn = css`
    background-image: linear-gradient(#FFFFFF,#FFF8E5);
    color: #F79C41;
`;
